<template>
  
    <v-app>
        
        <v-main>
    
            <!-- Barra preta -->
            <v-toolbar
                color="black"
                dense
                flat
                :style="{
                    'border-top-left-radius': '12px',
                    'border-top-right-radius': '8px',
                    'position': 'fixed',
                    'top': '64px',
                    'left': modoBarraLateral ? '70px' : '260px',
                    'width': modoBarraLateral ? 'calc(100% - 70px)' : 'calc(100% - 260px)',
                    'z-index': '999',
                    'transition': 'left 0.3s ease, width 0.3s ease'
                }"
            >        
                <!-- Barra de seleção/apresentação dos status e quantidade equipamentos -->
                <v-select
                    v-model="setorSelecionado"
                    :items="selecaoSetores"
                    item-title="nome"
                    item-value="id"
                    bg-color="black"
                    label="Selecione Setor"
                    @update:modelValue="trataSelecaoSetor"
                    @click:clear="limpaSetores"
                    clearable
                    style="margin-left: 10px; margin-top: 25px; width: 100%;"                    
                >                    
                </v-select>
                
                <!-- Botão de novo equipamento -->
                <v-spacer />   
                <v-col cols="auto">

                    <v-tooltip text="Novo Equipamento" location="top">

                        <template #activator="{ props }">

                            <v-btn
                                v-bind="props"
                                icon
                                large
                                class="rounded-button"
                                style="background-color: #4CAF50;"
                                @click="criaNovoEquipamento"
                            >
                                <v-icon color="white">mdi-plus</v-icon>
                            </v-btn> 

                        </template>               

                    </v-tooltip>

                </v-col>
                
            </v-toolbar>
            
            <v-container fluid class="pa-4">

                <v-card class="pa-4" style="width: 100%;">
                    
                    <!-- Campo de busca -->
                    <v-text-field
                        v-model="textoBuscaEquipamento"
                        label="Pesquisar"
                        placeholder="Digite sua busca..."
                        prepend-inner-icon="mdi-magnify"
                        variant="outlined"
                        :clearable="true"
                        @keyup.enter="carregaListaEquipamentos"
                        @click:clear="limpaDadosPesquisa"
                        @update:modelValue="atualizaParamentrosBusca"
                        style="margin-top: 60px;" 
                    >
                    
                        <template v-slot:append-inner>
                            <v-icon 
                                @click="carregaListaEquipamentos"
                                title="Recarregar lista"
                                style="cursor: pointer;"
                            >
                                mdi-reload
                            </v-icon>
                        </template>
                    </v-text-field>

                    <!-- Tabela de equipamentos -->
                    <v-data-table-server
                        item-value="idEquipamento"
                        v-model:options="opcoesTabelaEquipamentos"
                        :headers="headersEquipamentos"
                        :items="listaEquipamentos"
                        :loading="carregandoEquipamentos"
                        class="elevation-2 rounded-lg"
                        density="compact"
                        :items-length="totalEquipamentos"
                        :footer-props="{
                            'items-per-page-text': 'Itens por página'
                        }"
                        @update:options="atualizaOpcoesTabela"
                        :style="{ 
                            'font-family': 'Arial, sans-serif !important', 
                            'font-size': '11px !important' 
                        }"                        
                    >
                        <!-- Slot para renderizar cada linha -->
                        <template #item="{ item }">

                            <tr
                                @click="selecionarLinha(item.idEquipamento)"
                                :class="{ 'linha-chamado-selecionada': linhaSelecionada.includes(item.idEquipamento) }"
                                style="cursor: pointer;"
                            >
                                <!-- Ações agrupadas em menu -->
                                <td>
                                    <v-menu v-model="item.escondeMenu">

                                        <!-- Renderiza os botões de função da lista de equipamentos -->
                                        <template #activator="{ props }">

                                            <v-btn 
                                                icon 
                                                v-bind="props" 
                                                size="small"
                                                @click="selecionarLinha(item)"
                                            >
                                                <v-icon>mdi-dots-vertical</v-icon>
                                            </v-btn>
                                        </template>

                                        <!-- Lista de funções dos atalhos -->
                                        <v-list>
                                            
                                            <v-list-item @click.stop="editaEquipamento(item)">
                                                <v-icon start color="orange-darken-2">mdi-pencil</v-icon>
                                                Editar Equipamento
                                            </v-list-item>
                                            
                                            <v-list-item @click.stop="abrirModalMovimentacao(item, 0)">
                                                <v-icon start color="primary">mdi-truck-delivery</v-icon>
                                                Mover Equipamento
                                            </v-list-item>
                                            
                                            <v-list-item @click.stop="listaRegistrosEquipamento(item)">                                            
                                                <v-icon start color="red-lighten-1">mdi-clock-time-five-outline</v-icon>
                                                Registros Equipamento
                                            </v-list-item>

                                        </v-list>

                                    </v-menu>
                                    
                                </td>

                                <td>
                                    <a href="#" @click.prevent="editaEquipamento(item)">
                                        {{ item.idEquipamento }}
                                    </a>
                                </td>
                                <td>{{ item.equipamento }}</td>
                                <td>{{ item.modelo }}</td>
                                <td>{{ item.descricao }}</td>
                                <td>{{ item.idUltimoKit === 0 ? 'Nenhum' : item.idUltimoKit }}</td>
                                <td>{{ item.setor }}</td>
                            
                            </tr>

                             <!-- Linha expandida com registros equipamentos -->
                            <transition name="expand">

                                <tr v-if="linhaRegistroEquipamento(item.idEquipamento)">
                                    
                                    <td colspan="12" class="pa-0" style="background-color: #f5f5f5;">

                                        <div style="padding-left: 30px;">

                                            <div style="position: relative;">
                                                <v-btn
                                                    icon
                                                    color="blue"
                                                    size="x-small"
                                                    style="position: absolute; top: -2px; right: 8px; z-index: 10;"
                                                    @click.stop="fechaRegistrosEquipamento"
                                                >
                                                <v-icon>mdi-minus</v-icon>
                                                </v-btn>
                                            </div>

                                            <!-- Título do registro de equipamentos -->
                                            <div class="d-flex align-center mb-3 mt-2">

                                                <v-icon color="primary" class="mr-2">mdi-eye</v-icon>
                                                <div 
                                                    class="font-weight-medium" 
                                                    style="color: #1976d2; font-size: 16px; line-height: 1.4;">
                                                    Registros Equipamentos
                                                </div>
                                                <v-chip 
                                                    v-if="item.Registros && item.Registros.length > 0" 
                                                    class="ml-2" 
                                                    color="primary" 
                                                    size="small"
                                                >
                                                    {{ item.Registros.length }}
                                                </v-chip>
                                            </div>

                                            <v-table 
                                                dense 
                                                class="registros-table" 
                                                style="table-layout: fixed; width: 100%; font-size: 11px;">

                                                <colgroup>
                                                    <col style="width: 50px;" />
                                                    <col style="width: 100px;" />
                                                    <col style="width: auto;" />
                                                    <col style="width: auto;" />
                                                    <col style="width: auto;" />
                                                    <col style="width: auto;" />
                                                    <col style="width: auto;" />
                                                    <col style="width: auto;" />
                                                    <col style="width: auto;" />
                                                </colgroup>

                                                <thead>
                                                    <tr>
                                                        <th class="text-center">Código</th>
                                                        <th class="text-center">Equipamento</th>
                                                        <th class="text-center">Empresa Origem</th>
                                                        <th class="text-center">Setor Origem</th>
                                                        <th class="text-center">Empresa Destino</th>
                                                        <th class="text-center">Setor Destino</th>
                                                        <th class="text-center">Por Quem</th>
                                                        <th class="text-center">Data</th>
                                                        <th class="text-center">Motivo</th>
                                                    </tr>
                                                </thead>

                                                <tbody>

                                                    <tr
                                                        v-for="registroEquipamento in item.Registros"
                                                            :key="registroEquipamento.idEquipamento"
                                                            @click="linhaRegistroSelecionada = registroEquipamento.idEquipamento"
                                                            :class="{ 'linha-registro-selecionada': linhaRegistroSelecionada === registroEquipamento.idEquipamento }"
                                                    >
                                                        <td style="text-align:center;">
                                                            <a href="#" @click.prevent="abrirModalRegistro(item, registroEquipamento.idRegistroMovimentacoes)">
                                                                {{ registroEquipamento.idRegistroMovimentacoes }}
                                                            </a>                                                        
                                                        </td>
                                                        <td style="text-align:center;">{{ registroEquipamento.equipamento }}</td>
                                                        <td style="text-align:center;">{{ registroEquipamento.empresaOrigem }}</td>
                                                        <td style="text-align:center;">{{ registroEquipamento.setorOrigem }}</td>
                                                        <td style="text-align:center;">{{ registroEquipamento.empresaDestino }}</td>
                                                        <td style="text-align:center;">{{ registroEquipamento.setorDestino }}</td>
                                                        <td style="text-align:center;">{{ registroEquipamento.quemMovimentou }}</td>
                                                        <td style="text-align:center;">{{ proxy.$formataDataBrasil(registroEquipamento.dataMovimento) }}</td>
                                                        <td style="text-align:center;">{{ registroEquipamento.motivoMovimento }}</td>

                                                    </tr>

                                                    <tr v-if="!item.Registros || item.Registros.length === 0">
                                                        <td colspan="5" class="text-center text-grey">
                                                            Não existe nenhum registro para este chamado.
                                                        </td>
                                                    </tr>

                                                </tbody>

                                            </v-table>
                                        
                                        </div>

                                    </td>

                                </tr>

                            </transition>

                        </template>

                    </v-data-table-server>

                </v-card>

            </v-container>
    
            <!-- Modal de Movimentação -->
            <ModalMovimentacaoEquipamento
                ref="modalMovimentacaoRef"
                @movimentacao-concluida="onMovimentacaoConcluida"
                @fechar="onModalFechado"
            />

            <!-- Modal de visualização registro -->
            <ModalMostraRegistroEquipamento
                ref="modalMostraRegistroMovimentacaoRef"
            />
        </v-main>
  
    </v-app>

</template>

<script setup>

    /* DEPENDENCIAS E VARIAVEIS COMUNS */
    
    // Importa as funcionalidades do Vue
    import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
    
    // Importa axios para chamadas API
    import axios from 'axios'

    // Importa o emitter para comunicação entre componentes
    import '@vueup/vue-quill/dist/vue-quill.snow.css'

    // Importa o event bus
    import { emitter } from '../utils/eventBus'

    // Importa o componente do formulário de erros
    import { useErroStore } from '@/stores/erroStore'

    // Importa o componente do formulário de login
    import { useLoginStore } from '@/stores/loginStore'

    // Importa useRouter para acessar parâmetros de rota
    import { useRouter } from 'vue-router'

    // Importa o componente do Snackbar
    import { useSnackbarStore } from '@/stores/snackbar'

    // Retorna um objeto com informações internas sobre o componente que está sendo executado no momento    
    import { getCurrentInstance } from 'vue'

    // Importa modal de movimentação de equipamentos
    import ModalMovimentacaoEquipamento from '@/components/ModalMovimentacaoEquipamento.vue'

    // Importa modal de visualização de registro de equipamentos
    import ModalMostraRegistroEquipamento from '@/components/ModalMostraRegistroEquipamento.vue'

    // Carrega o endereço das ap
    const API_BASE_URL = import.meta.env.VITE_API_URL;
    
    // Importa a store de erros
    const erroStore = useErroStore()

    // Importa a store de chamados
    const loginStore = useLoginStore()

    // Acessa o ID da empresa via query param
    const router = useRouter();

    // Permite acessar rotinas globais
    const { proxy } = getCurrentInstance()

    /* VARIAVEIS DO FORMULÁRIO */
    
    // Estado local para o modo da barra lateral
    const modoBarraLateral = ref(false)
    
    // Formatar os dados para o v-select
    const selecaoSetores = ref([])

    const linhaRegistroSelecionada = ref(null)

    // Estado reativo para id setor selecionado
    const setorSelecionado = ref(null)

    // Salva o id do setor selecionado
    const idSetorSelecionado = ref(null)

    // Estado reativo para nome setor selecionado
    const nomeSetorSelecionado = ref(null)
    
    // Estado reativo para equipamento selecionado
    const idEquipamentoSelecao = ref(null)

    // Define o elemento v-text-field da pesquisa
    const textoBuscaEquipamento = ref('')

    // Importa a store do snackbar
    const snackbar = useSnackbarStore()
    
    // Variável referencia do modal de movimentação de equipamentos
    const modalMovimentacaoRef = ref(null)

    // Variável referencia do modal de movimentação de equipamentos
    const modalMostraRegistroMovimentacaoRef = ref(null)

    // Define elemento da lista de chamados
    const listaEquipamentos = ref([])
    
    // Define elemento que mostra a barra de progresso da carga de equipamentos
    const carregandoEquipamentos = ref(false)

    // Define elemento que mostra a barra de progresso da carga de setores
    const carregandoSetoresEmpresa = ref(false)

    // Total de itens da tabela
    const totalEquipamentos = ref(0)

    // Define array contendo o campo que deve ser ordenado inicialmente e a direção
    const opcoesTabelaEquipamentos = ref({ 
        page: 1,
        itemsPerPage: 10,
        sortBy: ['status'],
        sortDesc: [false]
    })
    
    // Opções buscar setores empresa
    const opcoesTabelaSetoresEmpresa = ref({
        page: 1,
        itemsPerPage: 10,
        sortBy: [{ key: 'nome', order: 'asc' }]
    })

    // Define variável com a linha selecionada chamado
    const linhaSelecionada = ref([])
    
    // Define variável informando que os comentários estão sendo mostrados
    const registrosExpandidos = ref([])
    
    // Define os cabeçalhos da tabela de chamados
    const headersEquipamentos = [
        { title: 'Funções', text: 'Funções', value: 'Funções', width: '1px', sortable: false },
        { title: 'Código', text: 'Código', value: 'idEquipamento', width: '1px', sortable: true },
        { title: 'Equipamento', text: 'Equipamento', value: 'equipamento', width: '40px', sortable: true },
        { title: 'Modelo', text: 'Modelo', value: 'modelo', width: '180px', sortable: true },
        { title: 'Descrição', text: 'Descrição', value: 'descricao', width: '380px', sortable: true },
        { title: 'Kit', text: 'Kit', value: 'idUltimoKit', width: '10px', sortable: true },
        { title: 'Setor', text: 'setor', value: 'setor', width: '280px', sortable: true }
    ]

    
    /* ROTINAS CONSTANTES DA PÁGINA DE CHAMADOS*/
    
    // Função para carregar os setores da empresa
    const carregarListaSetoresEmpresa = async () => {
        
        // Extrai parâmetros de forma segura e correta
        const opcoes = opcoesTabelaSetoresEmpresa.value

        // Ordenação - forma correta para Vuetify 3
        let ordenacaoPor = 'nome'
        let direcaoOrdenacao = 'asc'

        if (opcoes.sortBy && opcoes.sortBy.length > 0) {
            ordenacaoPor = opcoes.sortBy[0].key
            direcaoOrdenacao = opcoes.sortBy[0].order
        }
        
        try {

            // Verifica se já está carregando produtos da empresa
            if (carregandoSetoresEmpresa.value == false){
           
                // Sinaliza carga dos produtos da empresa
                carregandoSetoresEmpresa.value = true

                // Chama a API para buscar os colaboradores da empresa
                const respostaApi = await axios.get(`${API_BASE_URL}/administracao/carregaListaSetoresEmpresa/${loginStore.idEmpresa}`, { 
                    params:{
                        textoBuscaEquipamento: textoBuscaEquipamento.value,
                        ordenacaoPor: ordenacaoPor || 'nome',  
                        direcaoOrdenacao: direcaoOrdenacao || 'asc'
                    },
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`
                    }
                })

                // Busca os setores retornados pela api
                const setoresEmpresa = respostaApi.data.data 
                
                // Formatar os dados para o v-select
                selecaoSetores.value = setoresEmpresa.map(setor => ({
                    ...setor,
                    nome: setor.nome
                }))

                // Aguarda os elementos serem carregados
                await nextTick();

                // Busca último setor selecionado
                const idSelecaoSetorSalva = localStorage.getItem('setorSelecionado')

                // Sinaliza que os produtos da empresa foram carregados
                carregandoSetoresEmpresa.value = false

                // Verifica se o idSetor é valido
                if (!idSelecaoSetorSalva || isNaN(Number(idSelecaoSetorSalva)) || Number(idSelecaoSetorSalva) <= 0) {
                    return
                }
                
                // Busca id do setor no elemento v-select 
                const setorEncontrado = selecaoSetores.value.find(
                    setor => setor.id == idSelecaoSetorSalva
                )
                
                // Se o setor foi encontrado, aponta para o mesmo
                if (setorEncontrado) {
                    
                    // Salva o id do setor selecionado no localstorage
                    setorSelecionado.value = setorEncontrado.id
                    
                    // Salva o id do setor selecionado
                    idSetorSelecionado.value = setorEncontrado.id
        
                    // Salva o nome do setor selecionado
                    nomeSetorSelecionado.value = setorEncontrado.nome        
                    
                } else {

                    setorSelecionado.value = null
                    idSetorSelecionado.value = null
                    nomeSetorSelecionado.value = null
                }                
            }

        } catch (erro) {

            // Sinaliza que os produtos da empresa foram carregados
            carregandoSetoresEmpresa.value = false

            // Usa a store de erros para exibir o erro
            erroStore.exibirErro(erro)

        } finally {
            carregandoSetoresEmpresa.value = false
        }
    }

    // Esta função trata o evento do v-select de mudança de setor
    const trataSelecaoSetor = async (idSetor) => {

        // Verifica se o idSetor é valido
        if (!idSetor || isNaN(Number(idSetor)) || Number(idSetor) <= 0) {
            
            setorSelecionado.value = null
            listaEquipamentos.value = []
            totalEquipamentos.value = 0
            return
        }

        // Salva o setor selecionado
        setorSelecionado.value = idSetor
        
        // Busca dados do setor selecionado pelo seu id
        const setorEncontrado = selecaoSetores.value.find(setor => setor.id === setorSelecionado.value)
        
        // Salva o nome do setor selecionado
        nomeSetorSelecionado.value = setorEncontrado.nome
        
        // Salva o id do setor selecionado
        idSetorSelecionado.value = setorEncontrado.id
        
        // Salva no localStorage o idSetor selecionado
        localStorage.setItem('setorSelecionado', idSetorSelecionado.value)

        localStorage.setItem('nomeSetorSelecionado', nomeSetorSelecionado.value)
        
        // Carrega a lista de equipamentos
        await carregaListaEquipamentos()
    }
    
    // Salva o ID do equipamento selecionado
    const selecionarLinha = (item) => {        

        let idEquipamento;
        
        // Se item for um objeto (como no botão do menu)
        if (typeof item === 'object' && item.idEquipamento) {
            idEquipamento = item.idEquipamento;
        } 

        // Se item for apenas o ID (como no clique da linha)
        else {
        
            idEquipamento = item;
        }
        
        // Atualiza ambos os estados
        idEquipamentoSelecao.value = idEquipamento;
        linhaSelecionada.value = [idEquipamento];
        
        // Salva no localStorage se quiser persistência
        localStorage.setItem('ultimoEquipamentoSelecionado', idEquipamento);
    }

    const limpaSetores = async () => {
        
        localStorage.setItem('setorSelecionado','')
        listaEquipamentos.value = []
    }

    // Função para carregar os equipamentos do setor selecionado
    const carregaListaEquipamentos = async () => {

        // Busca o id do setor selecionado
        const idSetor = localStorage.getItem('setorSelecionado')

        // Testa se o valor retornado é válido
        if (!idSetor || isNaN(Number(idSetor)) || Number(idSetor) <= 0) {

            listaEquipamentos.value = []
            totalEquipamentos.value = 0
            
            snackbar.trigger('Selecione Um Setor Para Mostrar Equipamentos', 'warning');
            return
        }
        
        // Fecha registros abertos ao mudar de setor
        fechaRegistrosEquipamento() 
        
        // Blindagem contra estados intermediários
        const sortArray = Array.isArray(opcoesTabelaEquipamentos.value?.sortBy) 
            ? opcoesTabelaEquipamentos.value.sortBy 
            : []
        
        const primeiraOrdenacao = sortArray.length ? sortArray[0] : null

        // // 2) Defaults estáveis (sem jamais acessar [0] de algo indefinido)
        const ordenacaoPor = primeiraOrdenacao?.key ?? 'cadastro_equipamentos.equipamento'
        const direcaoOrdenacao = primeiraOrdenacao?.order ?? 'asc'

        // Extrai paginação
        const paginaAtual = opcoesTabelaEquipamentos.value.page ?? 1
        const itensPorPagina = opcoesTabelaEquipamentos.value.itemsPerPage ?? 10

        try {
        
            // Verifica se já está carregando para evitar chamadas concorrentes
            if (carregandoEquipamentos.value == false){

                // Inicia a barra de carregamento
                carregandoEquipamentos.value = true
                
                // Fazendo a requisição para buscar os chamados
                const { data } = await axios.get(`${API_BASE_URL}/operacao/carregaListaEquipamentos/${loginStore.idEmpresa}/setores/${idSetor}`, {
                    params: { 
                        textoBuscaEquipamento: textoBuscaEquipamento.value,
                        ordenacaoPor: ordenacaoPor,  
                        direcaoOrdenacao: direcaoOrdenacao,
                        paginaAtual: paginaAtual,
                        itensPorPagina: itensPorPagina                        
                    },
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`
                    }
                })

                // Verificando se a resposta contém dados
                const retorno = data.data || []

                // Se houver dados, formatar e atribuir aos headers e chamados
                if (retorno.length > 0) {
                    
                    // Carregando os dados na tabela
                    listaEquipamentos.value = retorno.map(equip => ({
                        ...equip,
                        Registros: [] // Garante que a propriedade existe e é reativa
                    }))

                    // Atualiza o total de chamados
                    totalEquipamentos.value = data.total || retorno.length

                } else {
                    listaEquipamentos.value = []
                }
            }

        } catch (erro) {  
            
            // Em caso de erro desliga indicador de carregamento e mostra o erro
            carregandoEquipamentos.value = false
            erroStore.exibirErro(erro)      

        } finally {
            carregandoEquipamentos.value = false
        }
    }

    // Função para lidar com mudanças nas opções da tabela
    const atualizaOpcoesTabela = (novasOpcoes) => {
        
        // Atualiza as opções
        opcoesTabelaEquipamentos.value = novasOpcoes
        
        // Só carrega dados se houver um setor selecionado
        if (setorSelecionado.value) {
            carregaListaEquipamentos()
        }
    }

    // Esta função abre modal de movimentação de equipamentos
    const abrirModalMovimentacao = async (item, idRegistroMovimentacoes) => {
        
        // Esconde menu
        item.escondeMenu = false

        // Verifique se a ref existe
        if (!modalMovimentacaoRef.value) {
            erroStore.exibirErro('Verifique se o componente ModalMovimentacaoEquipamento está no template')
            await nextTick() // Tenta novamente após o próximo tick
        }
        
        // Verifica se o modal existe
        if (modalMovimentacaoRef.value) {

            try {

                // Abre formulário modal passando os dados
                modalMovimentacaoRef.value.abrirModal({
                    idRegistroMovimentacoes: idRegistroMovimentacoes,
                    idEquipamento: idEquipamentoSelecao.value,
                    idEmpresaOrigem: loginStore.idEmpresa,
                    nomeEmpresaOrigem: loginStore.nomeFantasia,
                    idSetorOrigem: idSetorSelecionado.value,
                    nomeSetorOrigem: nomeSetorSelecionado.value,
                    equipamento: item.equipamento                   
                })

            } catch (erro) {
                erroStore.exibirErro('Erro ao abrir modal: ' + erro)
            }
        }
    }

    // Abre modal para visualizar registro de movimentação do equipamento
    const abrirModalRegistro = async (item, idRegistroMovimentacoes) => {
        
        // Esconde menu
        item.escondeMenu = false

        // Verifica se o modal existe
        if (modalMostraRegistroMovimentacaoRef.value) {

            try {

                // Abre formulário modal passando os dados
                modalMostraRegistroMovimentacaoRef.value.abrirModal({
                    idRegistroMovimentacoes: idRegistroMovimentacoes
                })

            } catch (erro) {
                erroStore.exibirErro('Erro ao abrir modal: ' + erro)
            }
        }
    }

    // Callback quando a movimentação é concluída
    const onMovimentacaoConcluida = (dadosMovimentacao) => {

        // Mostra que a movimentação foi concluída com sucesso
        snackbar.trigger('Equipamento Movido Com Sucesso!', 'success')
        
        // Recarregue a lista de equipamentos
        carregaListaEquipamentos()
    }

    // Callback quando o modal é fechado para carregar a lista de equipamentos
    const onModalFechado = () => {
        carregaListaEquipamentos()
    }


    /* FUNÇÕES ASSINCRONAS  */

    // Esta função carrega os comentários ou limpa a tabela caso não haja dados
    async function listaRegistrosEquipamento(item) {

        // Esconde menu
        item.escondeMenu = false

        // Busca o id do equipamento selecionado
        const idEquipamento = item.idEquipamento;
        
        // Fecha todos os registros expandidos para evitar múltiplas expansões
        registrosExpandidos.value = []

        try{

            // Expande e carrega registros
            registrosExpandidos.value.push(idEquipamento)

            // Busca a linha do chamado na lista
            const linhaListaRegistros = listaEquipamentos.value.find(buscaId => buscaId.idEquipamento === idEquipamento)

            // Busca lista de movimentações do equipamento
            const { data } = await axios.get(`${API_BASE_URL}/operacao/carregaListaMovimentacoes/${idEquipamento}`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            });
            
            // Busca os registros retornados pela api ou define como array vazio se não houver dados
            const retorno = data.data || []

            // Atribui os registros retornados para a linha do chamado encontrado
            linhaListaRegistros.Registros = retorno                

        }catch (erro) {
            erroStore.exibirErro(erro)
        }
    };

    // Fecha tabela de registros do equipamento
    function fechaRegistrosEquipamento() {

        // Remove o id do chamado da lista de registros expandidos para fechar a seção de registros
        registrosExpandidos.value = []
    }

    // Limpa campo de pesquisa quando o X é pressionado
    function limpaDadosPesquisa() {
        textoBuscaEquipamento.value = ''
    }

    // Esta fução trata da expansão do registro de chamado ao se clicar no ícone de comentários
    function linhaRegistroEquipamento(codigo) {
        return registrosExpandidos.value.includes(codigo)
    };

    // Esta função chama formulário para criar um novo equipamento
    function criaNovoEquipamento() {
        router.push({ name: 'CadastroEquipamentos', query: { idEmpresa: loginStore.idEmpresa, idSetor: setorSelecionado.value, idEquipamento: 0, modoBarraLateral: modoBarraLateral.value } })
    }

    // Esta função chama o cadastro de empresas para editar a empresa apontada por idEmail
    function editaEquipamento(item) {

        // Esconde menu
        item.escondeMenu = false

        // Salva o idEquipamento quando o menu for selecionado
        selecionarLinha(item.idEquipamento);

        router.push({ name: 'CadastroEquipamentos', query: { idEmpresa: loginStore.idEmpresa, idSetor: setorSelecionado.value, idEquipamento: item.idEquipamento, modoBarraLateral: modoBarraLateral.value } })
    }

    // Se o campo foi limpo, recarrega a lista de chamados        
    function atualizaParamentrosBusca(novoValor) {
        if (!novoValor) {
            carregaListaEquipamentos()
        }
    }
    
    // Esta função é chamada quando o formulário é carregado
    onMounted(() => {

        // Carrega lista de chamados
        carregarListaSetoresEmpresa()

        // Aguardo o DOM ser carregado
        nextTick()

        // Carrega lista de equipamentos
        carregaListaEquipamentos()
        
        // Listener para mudanças do drawer
        const manipuladorMudancaTamanho = (data) => {
            modoBarraLateral.value = data
        }

        // Adiciona listener para mudanças do drawer
        emitter.on('mudancaBarraLateral', manipuladorMudancaTamanho)

    })

    // Limpar o timer quando o componente for destruído
    onBeforeUnmount(() => {

        // Limpar listener
        emitter.off('mudancaBarraLateral')
    })
    
</script>


<style scoped>

    /* No estilo scoped */
    .linha-chamado-selecionada {
        background-color: #e6e6e6;
        color: rgb(15, 15, 15);
    }

    .linha-registro-selecionada {
        background-color: white !important;
    }

    tr {
        cursor: pointer;
    }

    .col-codigo a {
        color: inherit;
        text-decoration: none;
        font-weight: bold;
    }

    .col-codigo a:hover {
        text-decoration: underline;
        color: #1976d2;
    }
    
   .rounded-button {
        border-radius: 50%;
    }
    
    .v-icon {
        font-size: 20px;
    }
    
    /* Estilos para a tabela de comentários */
    .registros-table {
        width: 100%;
        table-layout: fixed;    /* respeita larguras fixas se houver */
        border-collapse: collapse;  /* faz as bordas “se tocarem” sem espaços */
    }

    /* Bordas horizontais: uma linha preta embaixo de cada célula do corpo */
    .registros-table tbody td {
        border-bottom: 1px solid #b4a4a4;
        padding: 8px 12px;      /* ajuste seu padding conforme o design */
    }

    /* Opcional: linha separadora abaixo do cabeçalho */
    .registros-table thead th {
        border-bottom: 2px solid #b4a4a4;
        padding: 8px 12px;
    }

    /* Remove a última linha horizontal (evita borda extra no final) */
    .registros-table tbody tr:last-child td {
        border-bottom: none;
    }

</style>
